"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
async function getDownloadSpeed({ chunks = 4, url = "" }) {
    const downloadTimes = [];
    let totalSize = 0;
    for (let i = 0; i < chunks; i++) {
        try {
            const downloadStartTime = performance.now();
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error(`Download failed with status: ${response.status}`);
            }
            await response.blob();
            totalSize += Number(response.headers.get("content-length")) || 0;
            const downloadEndTime = performance.now();
            const downloadTimeInSeconds = (downloadEndTime - downloadStartTime) / 1000;
            downloadTimes.push(downloadTimeInSeconds);
        }
        catch (error) {
            console.error("Speed test failed:", error);
        }
    }
    // Calculate the average download time
    const totalDownloadTime = downloadTimes.reduce((sum, time) => sum + time, 0);
    const averageDownloadTime = totalDownloadTime / downloadTimes.length;
    // Calculate download speed in Mbps
    const downloadSpeedMbps = ((totalSize / averageDownloadTime) * 8) / 1000000; // Mbps
    return (!isNaN(downloadSpeedMbps) && downloadSpeedMbps.toFixed(2)) || 0;
}
exports.default = getDownloadSpeed;
